import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import { Box, Container, Typography, Grid, Paper } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Cancel from '@material-ui/icons/Cancel'
import Moment from 'react-moment'
import moment from 'moment'

import './AttentionComponent.scss'
import { theme } from '../../classes/Themes'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import AttentionHeaderComponent from './AttentionHeaderComponent'
import Spinner from '../Spinner'
import Thumbnail from '../widgets/Thumbnail'
import DateHelpers from '../../classes/DateHelpers'
import AttentionIndexOnBoarding from './AttentionIndexOnBoarding'

export class AttentionComponent extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    history: PropTypes.object,
    location: PropTypes.object,
    homepage: PropTypes.object,
    classes: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    topAndTrending: PropTypes.object,
    attentionIndex: PropTypes.object,
    shortcutPreference: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      selectedTab: 'anticipation',
      anticipationData: [],
      topData: [],
      trendingData: [],
      startDate: '',
      endDate: ''
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.attentionIndex !== this.props.attentionIndex && this.props.attentionIndex.details) {
      const attentionIndex = this.props.attentionIndex.details
      const date = moment(attentionIndex.anticipation.length > 0 && attentionIndex.anticipation[0].metric_date).format('MM-DD-YYYY')
      const startDate = moment(date).subtract(6, 'days').format('MMM DD')
      const endDate = moment(date).subtract(0, 'days').format('MMM DD, YYYY')
      this.setState({
        anticipationData: attentionIndex.anticipation.length > 0 ? attentionIndex.anticipation[0].data.data : [],
        topData: attentionIndex.anticipation.length > 0 ? attentionIndex.top[0].data.data : [],
        trendingData: attentionIndex.anticipation.length > 0 ? attentionIndex.trending[0].data.data : [],
        startDate: startDate,
        endDate: endDate
      })
    }
  }

  getData = (data) => {
    let rows = []
    data && data.map(t => {
      if (t.rank !== 1) {
        rows.push({
          id: t.rank,
          title: t.display_name || t.name,
          type: t.entity_type,
          network: t.channel,
          premiere: t.active_date,
          trending: t.trend,
          thumbnail: t.thumbnail,
          entityOverrideImage: t.entity_override_image
        })
      }
    })
    return rows
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics for <strong>{this.state.selectedNetwork}</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }

    return (
      <AttentionIndexOnBoarding
        name={'Attention Index'}
        run={true}
      />
    )
  }

  render () {
    if (this.props.topAndTrending.isFetching || this.props.attentionIndex.isFetching) {
      return (<Spinner />)
    }
    let data = []
    let dataContent = null
    let titleText = ''
    if (this.state.selectedTab === 'top') {
      data = this.getData(this.state.topData)
      dataContent = this.state.topData && this.state.topData[0]
      titleText = 'Top Content'
    } else if (this.state.selectedTab === 'trending') {
      data = this.getData(this.state.trendingData)
      dataContent = this.state.trendingData && this.state.trendingData[0]
      titleText = 'Most Trending Content'
    } else {
      data = this.getData(this.state.anticipationData)
      dataContent = this.state.anticipationData && this.state.anticipationData[0]
      titleText = 'Most Anticipated Content'
    }
    return (
      <ThemeProvider theme={theme}>
        <div className="rightSide attentionWrap">
          <Container fluid="true" maxWidth="xl" className={this.props.classes.containerRootAA}>
            {this._renderShortcut()}
            {this._renderOnboarding()}
            <AttentionHeaderComponent
              homepage={this.props.homepage}
              history={this.props.history}
              shortcut={this.props.shortcut}
              setSelectedNetwork={this.setSelectedNetwork}
            />
            <Box className="dateTxt">
              <Typography>Results for week of {this.state.startDate} to {this.state.endDate} </Typography>
            </Box>
            <Paper className="paperBase">
              <Grid container spacing={1} direction="column">
                <Grid item className='cardPadding p-b-0' xs={12}>
                  <Box className="tabWrap">
                    <Box id="anticipationHeading" className={`${'tabTile '} ${this.state.selectedTab === 'anticipation' ? 'anticipationTabActive' : ''}`} onClick={() => this.changeTab('anticipation')}>
                      Anticipation
                    </Box>
                    <Box id="topHeading" className={`${'tabTile '} ${this.state.selectedTab === 'top' ? 'topTabActive' : ''}`} onClick={() => this.changeTab('top')}>
                      Top
                    </Box>
                    <Box id="trendingHeading" className={`${'tabTile '} ${this.state.selectedTab === 'trending' ? 'trendingTabActive' : ''}`} onClick={() => this.changeTab('trending')}>
                      Trending
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Box className="flex baseBox">
                <Box className={`${'boxInfo flexCenterCenter '} ${this.state.selectedTab === 'anticipation' ? 'anticipationActive' : this.state.selectedTab === 'top' ? 'topActive' : this.state.selectedTab === 'trending' ? 'trendingActive' : ''}`} >
                  <Box className="ribbonBox">
                    <Typography>1</Typography>
                  </Box>
                  <Box className="infoImg">
                    <Thumbnail
                      entityOverrideImage={dataContent && dataContent.entity_override_image}
                      thumbnail={dataContent && dataContent.thumbnail}
                      name={dataContent && dataContent.name}
                      noImgTextClass={'attentionHeadingNoImgText'}
                      noImgClass={'attentionHeadingNoImg'}
                      divId={'attention_heading'}
                    />
                  </Box>
                  <Box className="nameTxtBox">
                    <Typography className="nameTxt" variant="h5" gutterBottom>{dataContent && (dataContent.display_name || dataContent.name)}</Typography>
                  </Box>
                  <Typography className="typeTxt" variant="h5" gutterBottom>
                    { (dataContent && dataContent.entity_type) && <span>{dataContent.entity_type} . </span>}
                    { (dataContent && dataContent.channel) && <span>{dataContent.channel && dataContent.channel.length > 2 ? 'Multiple' : dataContent.channel && dataContent.channel === 2 ? dataContent.channel.join().replace(',', ', ') : dataContent.channel} . </span>}
                    { (dataContent && dataContent.genre) && <span>{dataContent.genre}</span>}
                  </Typography>
                  <Typography className="dateTxt"variant="h5" gutterBottom>Premiere: {dataContent && DateHelpers.formatDate(dataContent.active_date)}</Typography>
                  <Typography className="btnTxt" variant="h5" gutterBottom>{titleText}</Typography>
                </Box>
                <Box className="boxTable">
                  <TableView details={data} classes={this.props.classes}/>
                </Box>
              </Box>
            </Paper>
          </Container>
        </div>
      </ThemeProvider>
    )
  }

  changeTab = (type) => {
    this.setState({ selectedTab: type })
  }
}

export class TableView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    details: PropTypes.array.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      rowsPerPage: 3
    }
  }
  render () {
    const rows = this.props.details
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)

    return (
      <>
        <TableContainer className="commonTable attentionTable" id="attentionTable">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>&nbsp;</StyledTableCell>
                <StyledTableCell>&nbsp;</StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Type</StyledTableCell>
                <StyledTableCell>Network</StyledTableCell>
                <StyledTableCell>Premiere</StyledTableCell>
                <StyledTableCell><Box className="flexCenter justify-content-end">Trending</Box></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      <Thumbnail
                        entityOverrideImage={row.entityOverrideImage}
                        thumbnail={row.thumbnail}
                        name={row.title}
                        imageClass={'tableLogo'}
                        noImgTextClass={'attentionNoImgText'}
                        noImgClass={'attentionNoImg'}
                        divId={`attention_${index}`}
                      />
                    </TableCell>
                    <TableCell className="titleRow">{row.title}</TableCell>
                    <TableCell>{row.type}</TableCell>
                    <TableCell>{row.network && row.network.length > 2 ? 'Multiple' : row.network && row.network.length === 2 ? row.network.join().replace(',', ', ') : row.network}</TableCell>
                    <TableCell>{DateHelpers.formatDate(row.premiere)}</TableCell>
                    <TableCell><img src={`${row.trending === 'Up' ? '/static/images/up.svg' : row.trending === 'Down' ? '/static/images/down.svg' : row.trending === 'Flat' ? '/static/images/minus.svg' : ''}`}/></TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }
}

export default withStyles(styles)(AttentionComponent)
